import { LegacyRef, useCallback, useRef } from 'react';

const useInfiniteScroll = (
  isLoading: boolean,
  isFetching: boolean,
  hasNextPage: boolean,
  fetchNextPage: () => void
) => {
  const observer = useRef<IntersectionObserver>(null);

  const fetchElementRef = useCallback(
    (node: HTMLDivElement | HTMLSpanElement | LegacyRef<HTMLDivElement>) => {
      //Return if already fetching
      if (isLoading || isFetching) return;

      // Disconnect if already observer exists
      if (observer.current) observer.current.disconnect();

      //Create new observer for the last element, and call fetchNextPage if visible(isIntersecting)
      observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });
      if (node instanceof Element) observer.current.observe(node);
    },
    [isLoading, isFetching, hasNextPage]
  );

  return fetchElementRef;
};

export default useInfiniteScroll;
